import React, { useState } from 'react';
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { paymentModeCOlumn, tooltipDescMapping } from '../constant';
import ALoader from 'views/pages/manage/common/a-loader';
import { TooltipPopover } from './commons';
const ListComponent = ({ rows, type, loader }) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [colMapping, setColMapping] = useState([])

    const columns=paymentModeCOlumn?.[type]
        const handleClick = (event, row) => {
            setAnchorEl(event.currentTarget);
            setColMapping(row?.type)
        };
        
        const handleClose = () => {
            setAnchorEl(null);
        };
    return (<>
        <div className="" style={{ border: '1px solid #EEE', borderRadius: '8px' }}>
            {loader ? <ALoader position="fixed" /> :
                <ADataGrid
                    removeWrapperContainer
                    rowModesModel
                    rows={rows || []}
                    columns={columns(handleClick)}
                    rowId={(row) => JSON.stringify(row)}
                    rowHeight={50}
                    rowCount={rows.length}
                    loading={false}
                    components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                            <NoRowOverlay message={loader ? "Loading..." : null} />
                        ),
                    }}
                    sx={{
                        ...gridStyles,
                    }}
                    autoHeight
                    hidePagination={true}
                />
            }
        </div>
        <TooltipPopover
        anchorEl={anchorEl}
        handleClose={handleClose}
        desc={tooltipDescMapping?.[colMapping]}
        />
    </>
    );
}
export default ListComponent